import { useEffect, useState } from "react";
import { Accordion, Offcanvas } from "react-bootstrap";
import PrescriptionTable from "./PrescriptionTable";
import EmptyAssignment from "assets/svgs/empty_assignment";
import { FormOutlined } from "@ant-design/icons";
import CreatePrescription from "./CreatePrescription";
import { Tooltip } from "antd";
import PrescriptionForm from "./PrescriptionForm";
import PrescriptionScalpImage from "./PrescriptionScalpImage";
import SoftBadge from "modules/common/SoftBadge";
import { useDoctors, useDosages, useRootCauseData } from "./store";
import PrescriptionDenyModal from "./PrescriptionDenyModal";
import PrescriptionPastAccordian from "./PrescriptionPastAccordian";
import { isEmpty } from "lodash";
import RootCause from "./RootCause";
import HandleBackOperation from "./HandleBackOperation";

function Prescription({ order, prescriptionsData, currentId, customer }) {
  useEffect(() => {}, [currentId]);
  useEffect(() => {}, [prescriptionsData.prescription]);
  const [show, setShow] = useState(false);
  const [stage, setStage] = useState("");
  const [age, setAge] = useState("");
  const { dosagesData, dosages } = useDosages();
  const { assignedDoctorsData, fetchAssignedDoctorsData } = useDoctors();
  let prescriptions = [];
  let oneLinerPrescription = "";
  const [syntheticId, setSyntheticId] = useState("");
  const [rootData, setRootData] = useState([]);
  const { rootCauseData, rootCauseLoading, fetchRootCauseData } =
    useRootCauseData();

  useEffect(() => {
    setRootData(rootCauseData);
  }, [rootCauseData]);

  useEffect(() => {
    if(show){
      fetchAssignedDoctorsData(order?.id);
      dosagesData(order?.id);
    }
  }, [order?.id, show]);

  useEffect(() => {
    if (syntheticId) {
      fetchRootCauseData(syntheticId);
    }
  }, [syntheticId]);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setStage("");
    setAge("");
    // fetchAssignedDoctorsData(order?.id);
    // dosagesData(order?.id);
  };

  // useEffect(() => {
  //   dosagesData(order?.id);
  // }, [order?.id]);

  return (
    <>
      <Tooltip title="Prescription">
        <div className="rounded-circle shadow-lg" onClick={handleShow}>
          <span className="mt-n1 bg-primary text-white p-2 d-flex justify-content-center align-items-center rounded-circle shadow" id="prescriptionOutlined">
            <FormOutlined />
          </span>
        </div>
      </Tooltip>

      <Offcanvas
        style={{ width: "87vw" }}
        show={show}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Body>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title style={{}}></Offcanvas.Title>
          </Offcanvas.Header>
          <div className="d-flex justify-content-between gap-2">
            <div className="d-flex flex-column" style={{ width: "40%" }}>
              <div className="d-flex flex-column gap-2 card p-2 shadow mb-2">
                <div className="d-flex flex-wrap gap-2 p-3">
                  <div className="d-flex gap-2 align-items-center ">
                    <div className="fw-bold">Name :</div>
                    <div style={{ fontSize: "1.2rem" }}>
                      <SoftBadge pill bg="info" className="me-2">
                        {customer?.user?.first_name}
                      </SoftBadge>
                    </div>
                  </div>
                  <div className="d-flex gap-1 align-items-center">
                    <div className="fw-bold">Gender :</div>
                    <div style={{ fontSize: "1.2rem" }}>
                      <SoftBadge pill bg="info" className="me-2">
                        {customer?.user?.gender === "F" ? "Female" : "Male"}
                      </SoftBadge>
                    </div>
                  </div>

                  {stage ? (
                    <div className="d-flex gap-1 align-items-center">
                      <div className="fw-bold">Stage :</div>
                      <div style={{ fontSize: "1.2rem" }}>
                        <SoftBadge pill bg="info" className="me-2">
                          {stage}
                        </SoftBadge>
                      </div>
                    </div>
                  ) : null}

                  {age ? (
                    <div className="d-flex gap-1 align-items-center">
                      <div className="fw-bold">Age :</div>
                      <div style={{ fontSize: "1.2rem" }}>
                        <SoftBadge pill bg="info" className="me-2">
                          {age}
                        </SoftBadge>
                      </div>
                    </div>
                  ) : null}
                  {!isEmpty(rootData) ? (
                    <div className="d-flex align-items-center">
                      <div className="fw-bold">Root Cause :</div>{" "}
                      <div
                        className="text-wrap text-break"
                        style={{ fontSize: "1.2rem" }}
                      >
                        <SoftBadge pill bg="info" className="me-2 ms-1">
                          <RootCause rootData={rootData} />
                        </SoftBadge>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div>
                <div className="d-flex flex-column mb-1 gap-4">
                  <div className="shadow bg-white shadow rounded">
                    <PrescriptionScalpImage images={customer?.images} />
                  </div>
                  <div className="mt-n3">
                    <PrescriptionForm
                      customer={customer}
                      setStage={setStage}
                      setAge={setAge}
                      setSyntheticId={setSyntheticId}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card p-2" style={{ width: "60%" }}>
              <div className="d-flex flex-row justify-content-between">
                {!isEmpty(assignedDoctorsData) ? (
                  <div className="d-flex gap-2 align-items-center">
                    <span className="fw-bold">Assigned To :</span>
                    <span className="d-flex flex-wrap gap-1">
                      {!isEmpty(assignedDoctorsData) &&
                        assignedDoctorsData[0]?.doctor?.map((item) => {
                          return (
                            <div
                              className="pe-1"
                              style={{ fontSize: "1.35rem" }}
                            >
                              <SoftBadge pill bg="info" className="me-2">
                                {item?.user?.first_name}
                              </SoftBadge>
                            </div>
                          );
                        })}
                    </span>
                  </div>
                ) : (
                  <div></div>
                )}
                <div className="d-flex flex-row gap-2 justify-content-end">
                  <HandleBackOperation order={order} customer={customer} />
                  <div className="text-right me-3 text-end">
                    <PrescriptionDenyModal currentId={order?.order_display_id}/>
                  </div>
                </div>
              </div>
              <CreatePrescription
                order={order}
                prescriptionData={prescriptionsData}
                orderId={currentId}
                dosages={dosages}
                show={show}
              />
              <div
                className="scrollable-container shadow"
                style={{ maxHeight: "50vh", overflowY: "scroll" }}
              >
                {Array.isArray(prescriptionsData) &&
                  prescriptionsData.map((prescriptionData) => {
                    if (
                      prescriptionData.prescription !== undefined &&
                      prescriptionData.prescription !== "null"
                    ) {
                      try {
                        prescriptions = JSON.parse(
                          prescriptionData.prescription
                        ).prescription;
                      } catch (error) {
                        oneLinerPrescription = prescriptionData.prescription;
                      }
                      return (
                        currentId ===
                          prescriptionData.order.order_display_id && (
                          <PrescriptionTable
                            key={currentId}
                            prescriptionData={prescriptionData}
                            currentId={currentId}
                            prescriptions={prescriptions}
                            order={order}
                            oneLinerPrescription={oneLinerPrescription}
                            currentPrescription={true}
                            prescriptionsData={prescriptionsData}
                            prescriptionId={prescriptionData.id}
                          />
                        )
                      );
                    }
                  })}
              </div>
              <hr className="text-secondary p-2 "></hr>
              <div className="">
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <div className="m-2 fs-2 fw-bold text-black mb-3">
                        <SoftBadge bg="info" className="me-2 fs-2">
                          Past Prescriptions
                        </SoftBadge>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div
                        style={{
                          maxHeight: "50vh",
                          minHeight: "10vh",
                          overflowY: "scroll",
                        }}
                        className="flex-fill d-flex flex-column scrollable-container "
                      >
                        {Array.isArray(prescriptionsData) &&
                        prescriptionsData.length > 1 ? (
                          prescriptionsData.map((prescriptionData) => {
                            if (
                              prescriptionData.prescription !== "null" &&
                              prescriptionData.prescription
                            ) {
                              try {
                                prescriptions = JSON.parse(
                                  prescriptionData.prescription
                                ).prescription;
                              } catch (error) {
                                oneLinerPrescription =
                                  prescriptionData.prescription;
                              }

                              return (
                                prescriptionData.order.order_display_id !==
                                  currentId && (
                                  <PrescriptionPastAccordian
                                    currentId={
                                      prescriptionData.order.order_display_id
                                    }
                                    prescriptions={prescriptions}
                                    prescriptionData={prescriptionData}
                                  />
                                )
                              );
                            }
                          })
                        ) : (
                          <div
                            style={{ background: "#eee" }}
                            className="w-100 border rounded text-secondary fw-bold p-2 my-2 ps-4"
                          >
                            <EmptyAssignment />
                            <span className="ms-4">No Prescription data</span>
                          </div>
                        )}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
export default Prescription;
